/* Suave Forma · no pagar sin elegir la prenda gratis (31 oct)
   Con 2 medias pagadas toca 1 prenda gratis y con 3, 2 (misma regla que sf-xsell.js). Si la clienta toca
   «Pagar pedido» y aún no la eligió, se abre una hoja con las opciones; cada opción abre la vista rápida
   del carrito (la de sf-xsell.js). «Continuar sin regalo» deja pagar igual. */
(function () {
  if (window.__sfPayGuard) return; window.__sfPayGuard = true;
  var go = false, sheet;

  function pending(cart) {
    var paid = 0, free = 0;
    cart.items.forEach(function (i) {
      if (i.properties && i.properties._regalo) free += i.quantity;
      else if (i.product_type === 'Medias térmicas') paid += i.quantity;
    });
    return Math.max(0, (paid >= 3 ? 2 : paid === 2 ? 1 : 0) - free);
  }
  function img(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function close() { if (sheet) sheet.classList.remove('on'); document.documentElement.classList.remove('sfx-lock'); }

  function pay(btn) { close(); go = true; btn.click(); }

  /* abre la vista rápida de la opción i usando la tarjeta de regalo del carrito lateral */
  function choose(i) {
    close();
    var b = document.querySelector('cart-drawer .sfx-gift button[data-i="' + i + '"]');
    if (b) return b.click();
    var d = document.querySelector('cart-drawer');
    if (d && d.open) d.open(); else location.href = '/cart';
  }

  function ask(left, btn) {
    var items = (window.SFX_CONFIG && SFX_CONFIG.gift && SFX_CONFIG.gift.items) || [];
    if (!items.length) return pay(btn);
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.id = 'sfpg'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('.sfpg-x')) close(); });
    }
    Promise.all(items.map(function (x) {
      return fetch('/products/' + x.full + '.js').then(function (r) { return r.json(); }, function () { return {}; });
    })).then(function (ps) {
      sheet.innerHTML = '<div class="sfpg-bx"><button type="button" class="sfpg-x" aria-label="Cerrar">&times;</button>' +
        '<p class="sfpg-k">Antes de pagar</p>' +
        '<h3>' + (left > 1 ? 'Te faltan tus 2 prendas GRATIS' : 'Te falta tu prenda GRATIS') + '</h3>' +
        '<p class="sfpg-l">Ya está incluida en tu precio. Elige ' + (left > 1 ? 'la primera' : 'cuál quieres') + ' y la sumamos a tu pedido en $0:</p>' +
        '<div class="sfpg-gs">' + items.map(function (x, i) {
          var p = ps[i] || {};
          return '<button type="button" data-i="' + i + '"><img alt="" src="' + img(x.cartImg || p.featured_image, 200) + '"><b>' + esc(x.short) + '</b><span>GRATIS' + (p.price ? ' <s>$' + Math.round(p.price / 100) + '</s>' : '') + '</span></button>';
        }).join('') + '</div>' +
        '<button type="button" class="sfpg-skip">Continuar sin mi regalo</button></div>';
      sheet.querySelectorAll('.sfpg-gs button').forEach(function (b) { b.addEventListener('click', function () { choose(+b.dataset.i); }); });
      sheet.querySelector('.sfpg-skip').addEventListener('click', function () { pay(btn); });
      sheet.classList.add('on'); document.documentElement.classList.add('sfx-lock');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || go) return;
    e.preventDefault(); e.stopImmediatePropagation();
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var left = pending(cart);
      if (left > 0) ask(left, btn); else pay(btn);
    }, function () { pay(btn); });
  }, true);
})();
